import { render, staticRenderFns } from "./boton-cerrar-modal.vue?vue&type=template&id=2a5bf7ce&scoped=true&"
import script from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
export * from "./boton-cerrar-modal.vue?vue&type=script&lang=js&"
import style0 from "./boton-cerrar-modal.vue?vue&type=style&index=0&id=2a5bf7ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bf7ce",
  null
  
)

export default component.exports